/**
 * @generated SignedSource<<e3356edd82c878c010a94802fd94f256>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedTitle_buyPage$data = {
  readonly meta: {
    readonly header: string | null;
  } | null;
  readonly " $fragmentType": "BuySharedTitle_buyPage";
};
export type BuySharedTitle_buyPage$key = {
  readonly " $data"?: BuySharedTitle_buyPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedTitle_buyPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedTitle_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "ac579f5f8cd87e18c4f3dceb5683cbb5";

export default node;
